module.exports = __webpack_public_path__ + "img/green_091.9d2c031d.png";